import React, { Component } from 'react';
import { translate } from 'react-i18next';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

import FieldIconWrapper from 'common/components/form/FieldIconWrapper';

export default class FieldMultiSelect extends Component {
  render() {
    const {
      options,
      name = '',
      value = '',
      placeholder,
      autoFocus,
      inputSize,
      isLoading = false,
      handleChange = () => {},
      t,
      ...passThroughProps
    } = this.props;
    return (
      <FieldIconWrapper {...passThroughProps}>
        <Select
          className={classnames({
            'is-invalid': passThroughProps.error && Object.keys(passThroughProps.error).length > 0,
          })}
          isOpen={true}
          multi={true}
          options={options}
          isLoading={isLoading}
          name={name}
          value={value}
          joinValues={true}
          delimiter={','}
          simpleValue={true}
          placeholder={placeholder}
          onChange={(value) => handleChange({ target: { name: name, value } })}
        />
      </FieldIconWrapper>
    );
  }
}



// WEBPACK FOOTER //
// src/modules/common/components/form/FieldMultiSelect.js